var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.908698 1.5145C0.508783 0.847972 0.988896 0 1.76619 0H14.4338C14.7851 0 15.1106 0.184299 15.2913 0.485504L23.3826 13.971C23.7626 14.6044 23.7626 15.3956 23.3826 16.029L15.2913 29.5145C15.1106 29.8157 14.7851 30 14.4338 30H1.76619C0.988896 30 0.508783 29.152 0.908697 28.4855L8.3826 16.029C8.76262 15.3956 8.76262 14.6044 8.3826 13.971L0.908698 1.5145Z",
    fill: "#4272A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4);
export default __webpack_public_path__ + "static/media/a4.3bf0e78f4ba1ca94136e2fb6b45e7381.svg";
export { ForwardRef as ReactComponent };